import PropTypes from 'prop-types';
import {fullDataDataProps} from './propTypesFullData.js';

export const DownloadTourGpsProps = {
	addedItem: PropTypes.shape(fullDataDataProps),
	coord: PropTypes.arrayOf(PropTypes.number),
	data: PropTypes.arrayOf(PropTypes.shape(fullDataDataProps)),
	open: PropTypes.bool,
	openBasket: PropTypes.bool,
} 